import {React, observer, classNames, Popover2} from '@api'
import {ContentTitleBarItemField, useStores, ChangeLogFilterFieldConfig} from '@design-board'
import {Button} from '@material-ui/core'
import {ArrowDropDown, ArrowDropUp} from '@material-ui/icons'
import {SearchField2} from 'centric-ui-components'
import {useState} from 'react'
import * as css from './SearchPopover.css'

/// region Components

interface MyProps {
  className?: string
  onSearch: (e) => void
  searchText: string
  text: any
  selectedEl?: any
  btnClassName?: any
  hideSearch?: boolean
}

const SearchPopoverContent = observer<MyProps>(function SearchPopoverContent({className, children, onSearch, searchText, selectedEl, hideSearch, ...props}) {
  const {strings} = useStores()
  return (
    <>
      {hideSearch !== true && <SearchField2 data-type={'search-field'} className={css.search} active autoFocus onSearch={onSearch} value={searchText}/>}
      {selectedEl && <div className={css.fixed}>
		  <div className={css.dividerText}>{strings.applied}</div>
        {selectedEl}
		  <div className={css.dividerText}>{strings.all}</div>
	  </div>}
      <div className={css.filterFieldList} data-search-hidden={hideSearch}>
        {children}
      </div>
    </>
  )
})

export const SearchPopover = observer<MyProps>(function SearchPopover({...props}) {
  const [open, setOpen] = useState(false)
  return (
    <div className={classNames(css.root, props.className)}>
      <Popover2 usePortal={false}
                enforceFocus
                lazy
                autoFocus
                positioningStrategy={'fixed'}
                onClosing={() => setOpen(false)}
                onOpening={() => setOpen(true)}
                position={'bottom-left'}
                interactionKind={'click'}
                content={<SearchPopoverContent {...props}/>}>
        <Button disableFocusRipple
                disableRipple
                disableTouchRipple
                data-active={open}
                onClick={() => setOpen(!open)}
                className={props.btnClassName ?? ''}
                endIcon={open ? <ArrowDropUp/> : <ArrowDropDown/>}>
          {props.text}
        </Button>
      </Popover2>
    </div>
  )
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/common/components/SearchPopover.tsx